<nb-card>
  <nb-card-header class="header">
    <img src="assets/images/risk-report.jpg" alt="RISK" class="risk-indicator-image" />
    <div class="title">{{ "site_control_reports.control_report_title" | translate }}</div>
    <span class="close-btn" (click)="cancel()">
      <i class="fa-light fa-x"></i>
    </span>
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <label>{{ "site_control_reports.enter_report_code" | translate }}</label>
      <input
        nbInput
        type="text"
        [(ngModel)]="reportCode"
        fullWidth
        placeholder=""
        (keyup.enter)="import()"
      />
    </div>
  </nb-card-body>
  <div class="sticky-save-container">
    <div class="sticky-save-button">
      <button nbButton status="primary" (click)="import()" [disabled]="!reportCode || !reportCode.trim()">
        {{ "site_control_reports.import" | translate }}
      </button>
    </div>
  </div>
</nb-card>

